import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import { TableRow, TableCell } from "@material-ui/core";

import Options from "./options";

const RowTable = props => {
  const { isItemSelected, row } = props;
  const [anchorEl, setAnchorEl] = useState(undefined);
  const [menuState, setMenuState] = useState(false);

  const openMenuOptions = event => {
    setMenuState(true);
    setAnchorEl(event.currentTarget);
  };
  const closeMenuOptions = () => {
    setMenuState(false);
  };
  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      selected={isItemSelected}
    >
      <TableCell align="left">{row.name}</TableCell>
      <TableCell align="left">{row.description || 'N/A'}</TableCell>
      <TableCell align="left">{row.status ? "Activo" : "Inactivo" || "No registrado"}</TableCell>
      <TableCell align="left">{row.createdAt != null ? new Date(row.createdAt).toLocaleString() : 'Sin fecha' }</TableCell>
      <TableCell align="right">
        <IconButton onClick={openMenuOptions}>
          <MoreVert />
        </IconButton>
        <Options
          menuState={menuState}
          anchorEl={anchorEl}
          handleRequestClose={closeMenuOptions}
          id={row.id}
        />
      </TableCell>
    </TableRow>
  );
};

export default RowTable;